import * as React from "react";
import styled, { css } from "styled-components";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { ExternalLink } from "components/common";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const StyledOl = styled.ol(
  ({ theme }) => css`
    padding-left: 20px;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const GcsRepositorySetupInfo = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: "Setting up a Google Cloud Storage repository" }, /* @__PURE__ */ React.createElement(StyledOl, null, /* @__PURE__ */ React.createElement("li", null, "Create a Google Cloud Storage bucket. See Google\u2018s documentation on", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/storage/docs/creating-buckets" }, "Buckets"), "."), /* @__PURE__ */ React.createElement("li", null, "Create a service account for OpenSearch with read and write access to the bucket, because OpenSearch writes the snapshots. See Google\u2018s documentation on", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/iam/docs/service-account-overview" }, "Service Accounts"), "."), /* @__PURE__ */ React.createElement("li", null, "Add the key of that service account to the OpenSearch keystore."), /* @__PURE__ */ React.createElement("li", null, "Give ", productName, " read access to the bucket. Upload the key of a service account with read access (it can be the same account), or choose Automatic to use", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/docs/authentication/provide-credentials-adc#how-to" }, "Application Default Credentials"), " ", "on each ", productName, " node."), /* @__PURE__ */ React.createElement("li", null, "Enter the name of the bucket and the base path below.")));
};
export default GcsRepositorySetupInfo;
